import { useCallback } from "react";
import CurrencyFormat from "react-currency-format";
import './classification-card.scss';

function ClassificationCard({
   loading,
   brandAssocId,
   clipCount,
   ave
} : {
   loading: boolean,
   brandAssocId: number,
   clipCount: number,
   ave: number
}) {
   const getClassificationIcon = useCallback(()=>{
      switch(brandAssocId) {
         case 0 : return "fal fa-globe";
         case 1 : return "fa fa-user-crown";
         case 2 : return "fa fa-users-crown";
         case 3 : return "fa fa-comments";
      }
   }, [brandAssocId]);

   return (
      <div className={`classification-card brand-assoc-id-${brandAssocId}`}>
         <i className={`fab ${getClassificationIcon()}`}></i>
         <p className="clip-count">{loading ? <i className="fal fa-spinner fa-spin"></i> : clipCount}</p>
         <p className="ave">{loading ? <i className="fal fa-spinner fa-spin"></i> : <CurrencyFormat value={ave.toFixed(2)} prefix="R" displayType="text" thousandSeparator={true} />}</p>
      </div>
   )
}

export default ClassificationCard;